// External libraries
import React from 'react';
// @ts-expect-error TODO:@checkout/react-components
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { FLAG_SPRITE_POSITION_MAP } from '@/styles';
import {
  dropdownLabelStyleOverrides,
  getDropdownContainerStyleOverrides,
} from './styles';
import type { InputOnBlurChange, InputOnChange, InputOnFocus } from '@/types';
import { features } from '@/lib';

interface DialingCodeSelectProps {
  blurHandler?: InputOnBlurChange;
  changeHandler: InputOnChange;
  dialingCode?: {
    displayError: boolean;
    error: string;
    value: string;
  };
  dialingCodeSelectOptions: { key: string; text: string; value: string }[];
  disabled?: boolean;
  focusHandler?: InputOnFocus;
  value: string;
}

export const DialingCodeSelect = (
  props: DialingCodeSelectProps,
): React.ReactElement => {
  // Added 16 to the index to center it in the select
  // component, without which the flag would cut in half.
  const flagPos = FLAG_SPRITE_POSITION_MAP[props?.value] + 16;
  const { dialingCodeSelectOptions, ...propsToSpread } = props;
  const theme = features.get('rebrandFormFieldsTheme');

  return (
    <FloatingLabelSelect
      data-testid="dialingCode"
      floatingLabelContainerStyleOverrides={getDropdownContainerStyleOverrides(
        flagPos,
      )}
      focusedClassName="is-focused"
      id="dialingCode"
      name="dialingCode"
      className={'dialingCodeSelect'}
      required={true}
      selectOptions={dialingCodeSelectOptions}
      selectStyleOverrides={dropdownLabelStyleOverrides}
      isRightRadiusSquared={true}
      theme={theme}
      {...propsToSpread}
    />
  );
};
